import FirstVisitImage from './FirstVisitImage';

export default FirstVisitImage;
